import { useQuery } from '@tanstack/react-query';

import { integrationsEndpoints as endpoints } from '@/api/endpoints';
import { API } from '@/hooks/useIntegrations';
import { LiveChatIntegration } from '@/shared/types/integration';

export type LiveChatConnection = 'not_connected' | 'setting_up' | 'connected';

const SETUP_POLL_INTERVAL_MS = 3000;

// The OAuth callback saves the refresh token, then integrations-controller creates the bot and saves `author_id`.
const toConnection = (integration?: LiveChatIntegration): LiveChatConnection => {
  if (!integration?.config?.refresh_token) {
    return 'not_connected';
  }
  return integration.config.author_id ? 'connected' : 'setting_up';
};

// Same query key as `useIntegrations`, so it reads the integration that hook already fetched.
export const useLiveChatConnection = (deskId: string, integrationId: string) => {
  const { data = 'not_connected' } = useQuery<LiveChatIntegration, Error, LiveChatConnection>({
    queryKey: [endpoints.integration(deskId, integrationId)],
    queryFn: () => API.getIntegration<LiveChatIntegration>(deskId, integrationId),
    enabled: Boolean(deskId && integrationId),
    select: toConnection,
    refetchInterval: ({ state }) =>
      toConnection(state.data) === 'setting_up' ? SETUP_POLL_INTERVAL_MS : false,
  });

  return data;
};
